<ion-button
  fill="clear"
  shape="round"
  color="danger"
  [attr.aria-label]="'vehicles.delete' | translate"
  (click)="confirmDelete()"
>
  <ion-icon
    slot="icon-only"
    aria-hidden="true"
    src="../assets/material-symbols/delete_24dp.svg"
  ></ion-icon>
</ion-button>
